<template>
  <el-submenu v-if="getFilteredCategories" v-clickoutside="handleClickOutsideSubmenu" index="products"
    popper-class="desktop-nav" ref="products" :router="true">
    <template slot="title">{{ $t('menuProducts') }}</template>
    <!-- Top Level entries like "Outboard motors" or "Mercruiser" -->
    <nav-desktop-products-column v-for="(category0, key0) in getFilteredCategories" :key="key0" :category="category0"
      :index-prefix="`products-c${key0}`">
    </nav-desktop-products-column>
  </el-submenu>
</template>

<script>
import clickoutside from '@/directives/clickoutside';
import products from '@/components/products';
import mixins from '@/mixins';
import NavDesktopProductsColumn from './NavDesktopProductsColumn.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'NavDesktopProducts',
  directives: {
    clickoutside
  },
  mixins: [
    mixins.supportedFeatures
  ],
  props: {
  },
  data: () => {
    return {
    };
  },
  computed: {
    ...mapGetters(products.store.namespace, [
      'getFilteredCategories'
    ]),
  },
  methods: {
    escapeListener(e) {
      if (e.key == 'Escape') {
        const desktopNav = document.getElementsByClassName('desktop-nav')[0];
        if (desktopNav.offsetParent !== null) {
          this.$refs.products.handleClick();
        }
      }
    },
    handleClickOutsideSubmenu() {
      if (this.$refs["products"].$el.classList.contains("is-opened")) {
        this.$emit('closeSubmenu');
      }
    },
  },
  mounted() {
    window.addEventListener('keyup', this.escapeListener);
  },
  unmounted() {
    window.removeEventListener('keyup', this.escapeListener);
  },
  components: {
    NavDesktopProductsColumn
  },
}
</script>

<style lang="scss">
@import '@/assets/base/_variables.scss';

.desktop-nav {
  left: 0 !important;
  right: 0 !important;

  &>.el-menu.el-menu--popup.el-menu--popup-bottom-start {
    // element ui is adding a 5px gap
    margin-top: 0 !important;
    padding: 1.5rem 1.5rem 1.5rem 1.5rem;
    border-top: 1px solid $--color-grayscale-2;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    column-gap: 1.5rem;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    height: 60vh;
    box-shadow: 0 5px 5px rgba(0, 0, 0, .2);

    // Cleaning up some element-ui assumptions
    &::before,
    &::after {
      display: none;
    }
  }
}
</style>
